import { IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import { Link } from '@cian/ui-kit/link';
import { ArticleHeading1, Body2 } from '@cian/ui-kit/typography';

import { MetroIcon } from './components/MetroIcon';
import type { TMetroIcon } from 'shared/constants/buildingLabels';
import type { IUndergroundView } from 'shared/utils/buildingMainBlock';

import style from './style.css';

export interface IBuildingHeaderProps {
  /** Ссылка на основное здание — только у корпуса */
  parent: { label: string; url: string } | null;
  title: string;
  address: string;
  /** Адрес ведёт к карте, если у здания есть координаты */
  isAddressLink: boolean;
  undergrounds: IUndergroundView[];
  metroIcon: TMetroIcon;
}

export const BuildingHeader = ({
  parent,
  title,
  address,
  isAddressLink,
  undergrounds,
  metroIcon,
}: IBuildingHeaderProps) => (
  <header className={style['container']} data-name="BuildingHeader">
    {parent && (
      <div>
        <Link href={parent.url} fontSize="S">
          {parent.label}
        </Link>
      </div>
    )}
    <ArticleHeading1 as="h1">{title}</ArticleHeading1>
    <address className={style['address']}>
      {isAddressLink ? (
        <Link href="#map" fontSize="S" beforeIcon={<IconMapPin16 color="icon-main-default" />}>
          {address}
        </Link>
      ) : (
        <span className={style['address-text']}>
          <IconMapPin16 color="icon-main-default" />
          <Body2>{address}</Body2>
        </span>
      )}
    </address>
    {undergrounds.length > 0 && (
      <ul className={style['undergrounds']}>
        {undergrounds.map(({ name, color, timeText }, index) => (
          <li key={`${name}-${index}`} className={style['underground']} data-name="Underground">
            <MetroIcon icon={metroIcon} color={color} />
            <Body2>
              {name}
              {timeText && <span className={style['time']}>, {timeText}</span>}
            </Body2>
          </li>
        ))}
      </ul>
    )}
  </header>
);
